<div class="x-card x-card_size_m x-white card-shadow">
  @if ((canLogistChangeInstaller$ | async) === false) {
    <div class="x-card__title text-center text-(--x-color-danger) mt-10">
      <h5 class="typo-h5">
        {{ 'group_actions.status.no_access' | translate }}
      </h5>
    </div>
  } @else if (!requestIds().length) {
    <div class="x-card__title text-center text-(--x-color-danger) mt-10">
      <h5 class="typo-h5">
        {{
          'group_actions.installer_assignment.no_selected_requests' | translate
        }}
      </h5>
    </div>
  } @else if (hasMixedOwners()) {
    <div class="x-card__title text-center text-(--x-color-danger) mt-10">
      <h5 class="typo-h5">
        {{ 'group_actions.installer_assignment.mixed_owners' | translate }}
      </h5>
    </div>
  } @else {
    <x-request-installer-assignment-form
      [requestIds]="requestIds()"
      [ownerId]="ownerId()!"
      [titleKey]="null"
      [showCancel]="false"
      (completedOutput)="handleCompleted()"
    />
  }
</div>
